declare namespace $ {

	export class $exso_logo_favicon extends $mol_object {
	}
	
}

//# sourceMappingURL=favicon.view.tree.d.ts.map